'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishTypicalResponseTimeMessage = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _SenderIds = require('conversations-schema/constants/SenderIds');

var _TypicalResponseTimeMessageMetadata = require('conversations-schema/records/PubNubMessageMetadata/TypicalResponseTimeMessageMetadata');

var _TypicalResponseTimeMessageMetadata2 = _interopRequireDefault(_TypicalResponseTimeMessageMetadata);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getAvailabilityTypicalResponseTimeMessage = require('../availability/selectors/getAvailabilityTypicalResponseTimeMessage');

var _getWidgetTypicalResponseTime = require('./selectors/getWidgetTypicalResponseTime');

var _getThreadByChannel = require('../threads/selectors/getThreadByChannel');

var _publishMessageToConversation = require('../actions/PublishActions/publishMessageToConversation');

var _trackInteraction = require('../usage-tracking/actions/trackInteraction');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishTypicalResponseTimeMessage = exports.publishTypicalResponseTimeMessage = function publishTypicalResponseTimeMessage(_ref) {
  var channel = _ref.channel;
  return function (dispatch, getState) {
    var threadId = (0, _pipe2.default)(function (state) {
      return (0, _getThreadByChannel.getThreadByChannel)(state, { channel: channel });
    }, _threadGetters.getThreadId)(getState());

    var message = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
      descriptor: {
        channel: channel
      },
      metadata: (0, _TypicalResponseTimeMessageMetadata2.default)({
        text: (0, _getAvailabilityTypicalResponseTimeMessage.getAvailabilityTypicalResponseTimeMessage)(getState()),
        typicalResponseTime: (0, _getWidgetTypicalResponseTime.getWidgetTypicalResponseTime)(getState())
      }),
      senderId: _SenderIds.SYSTEM_ID,
      senderType: _senderTypes.SYSTEM,
      threadId: threadId
    });

    dispatch((0, _publishMessageToConversation.publishMessageToConversation)({ channel: channel, message: message }));

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'view reply time'
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/typical-response-time/publishTypicalResponseTimeMessage.js
// module id = 394
// module chunks = 2 3